var change = "変更する";
var edit = "編集";
var loading = "読み込み中";
var logout = "ログアウト";
var support = "オンラインヘルプセンター";
var more = "もっと";
var yes = "はい";
var no = "いいえ";
var exit = "出口";
var you = "君は";
var search = "検索";
var ja = {
	"business-unit": "事業単位",
	"ces-administration": "CES管理",
	change: change,
	"change-business-unit": "ビジネスユニットの変更",
	edit: edit,
	loading: loading,
	logout: logout,
	"no-application-available": "利用可能なアプリケーションはありません。",
	"select-a-business-unit-to-change": "変更先のビジネスユニットを選択します。事業部門が現在のアプリケーションを使用していない場合は、自分のプロフィールが表示されます。",
	support: support,
	"system-administration": "システム管理",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "少し前に<bold>{{name}}</bold>に切り替えました。ここで<bold>{{name}}</ bold>を切り替えますか？",
	"business-unit-has-changed": "ビジネスユニットが変更されました",
	exit: exit,
	"impersonated-user": "なりすましユーザー",
	you: you,
	"no-business-unit-assigned": "ビジネスユニットが割り当てられていません",
	"explore-marigold": "探検Marigold",
	"no-data-to-display": "表示するデータがありません",
	search: search
};

export { change, ja as default, edit, exit, loading, logout, more, no, search, support, yes, you };
